<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Festivals (Multi-Category)
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p>Festivals (Multi-Category) experienced a decline in revenue (by 20.3% from $69.0m in 2018 to $55.0m in 2019) and a decline in attendance by 15.7% (from 2.6m in 2018 to 2.2m in 2019). The average ticket price declined by 17.8% (from $40.52 in 2018 to $33.31 in 2019), which further contributed to the decline in revenue.</p>
          <p>In 2019, the major contributing events in this category were Adelaide Fringe, Fringe World Festival and Dark Mofo Festival.</p>
          <p>Bans on mass gatherings, border closures and density limits introduced as part of COVID-19 restrictions resulted in a decline in revenue (by 28.2% to $39.5m from 2019) and a decline in attendance (by 27.9% to 1.6m) in 2020. Additionally, a decline in the average ticket price by 14.0% (to $28.66) further contributed to the decline in revenue. The major contributing events in this category in 2020 were Adelaide Fringe, Fringe World Festival and Adelaide Festival.</p>
          <p>Festivals (Multi-Category) contributed 2.8% of the total share in revenue and 9.1% of the total share in attendance in 2019, followed by 6.5% of the total share in revenue and 20.2% of the total share in attendance in 2020.</p>
        </div>
        <div class="sixcol last">
          <p>In 2019, SA and WA generated the majority of the revenue (a combined 63.9% market share), while SA and VIC generated the majority of the attendance (a combined 68.6% market share).</p>
          <p>In 2020, SA and WA generated the majority of revenue and attendance in this category, with a combined 91.4% market share of revenue and 91.7% of attendance.</p>
          <p>In 2019, all states experienced a decline in revenue, while all states except Victoria, SA and WA experienced a decline in attendance in this category.</p>
          <p>In 2020, all states except SA experienced a decline in revenue, while all states except WA experienced a decline in attendance in this category. SA witnessed a 12.3% y-o-y increase in revenue, despite a moderate decline in attendance by 0.5%. Major events in SA in this category included Adelaide Fringe and Adelaide Festival, which were substantially presented prior to COVID-19 restrictions.</p>
        </div>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="classical-music-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <ul class="switches">
          <li><a href="javascript:;" :class="{active: activeYear==2019}"
            @click="activeYear=2019">2019</a></li>
          <li><a href="javascript:;" :class="{active: activeYear==2020}"
            @click="activeYear=2020">2020</a></li>
        </ul>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.</div>
        </div>
      </div>
    </figure>

    <div class="fullbg">
      <p class="caption">Photo: <em>Velma Celli's A Brief History of Drag</em>, Fringe World, Photo Credit: Kaifu Deng</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function() {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            } else {
              revy = '$' + rev.y + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          x: 120,
          verticalAlign: 'top',
          y: 100,
          floating: true,
          backgroundColor: '#fff'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [14.842, 5.171, 9.633, 9.318, 21.616, 10.643, 9.571, 11.777, 12.917, 25.622, 47.805, 62.162, 56.642, 54.636, 68.973, 54.985, 39.493],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [0.484, 0.157, 0.202, 0.294, 0.552, 0.431, 0.263, 0.242, 0.261, 0.787, 1.06, 1.487, 1.549, 1.866, 2.578, 2.174, 1.568],
          color: '#d14967'
        }]
      },
      activeYear: 2019,
      stateBreakdowns: [
        {
          year: 2019,
          revenue: [
            ["NSW", 10.9],
            ["VIC", 12.6],
            ["QLD", 5.5],
            ["WA", 24.9],
            ["SA", 38.9],
            ["ACT", 0.0],
            ["TAS", 7.2],
            ["NT", 0.0]
          ],
          attendance: [
            ["NSW", 3.1],
            ["VIC", 23.2],
            ["QLD", 4.2],
            ["WA", 20.8],
            ["SA", 45.4],
            ["ACT", 0.0],
            ["TAS", 3.3],
            ["NT", 0.0]
          ]
        },
        {
          year: 2020,
          revenue: [
            ["NSW", 2.8],
            ["VIC", 3.3],
            ["QLD", 1.0],
            ["WA", 30.5],
            ["SA", 60.9],
            ["ACT", 0.0],
            ["TAS", 1.6],
            ["NT", 0.0]
          ],
          attendance: [
            ["NSW", 2.1],
            ["VIC", 3.1],
            ["QLD", 0.7],
            ["WA", 29.0],
            ["SA", 62.7],
            ["ACT", 0.0],
            ["TAS", 2.4],
            ["NT", 0.0]
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [{
              name: 'Revenue Share',
              data: stateBreakdown.revenue,
              size: '68%',
              innerSize: '40%',
              borderColor: 'none',
              borderWidth: 1,
              slicedOffset: 30,
              showInLegend: true,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none',
                },
                formatter: function() {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -28
              }
            }, {
              name: 'Attendance Share',
              data: stateBreakdown.attendance,
              size: '100%',
              innerSize: '70%',
              borderColor: 'transparent',
              borderWidth: 1,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none',
                },
                formatter: function() {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -32
              }
            }],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("../../../assets/img/2019/Velma-Celli's-A-Brief-History-of-Drag,-Fringe-World,-Kaifu-Deng_SFW2.jpg");
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
